<script lang="ts">
    import Esi from '@shared/components/esi/Esi.svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import EekSheet from '@tilelist/components/eek-sheet/EekSheet.svelte';
    import RatingSheets from '../rating-sheets/RatingSheets.svelte';

    const wiring = injectWiring();
    const showBenefitCinema = $derived(!wiring.onex.isToggleActive('EMERGENCY_DISABLE_BENEFIT_CINEMA'));
</script>

<!--
Loads the benefit-cinema JS assets once per page while the feature is enabled. The
toggle must also cover lite and fallback pages, which render this shared component.
-->
{#if showBenefitCinema}
    <Esi src="/benefit-cinema/cinema/productlist/assets" />
{/if}

<RatingSheets />
<EekSheet />
